import React from "react";
import classNames from "classnames";
import ClipLoader from "react-spinners/ClipLoader";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import QuickCheckoutFavoriteStar from "../Parts/QuickCheckoutFavoriteStar";

export default class ServiceObject extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Services._name);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		const object = this.state;
		if (typeof this.props.updateName === "function") {
			this.props.updateName(object.name);
		}
	}

	form = () => {
		const {properties} = this.model;
		const object = this.state;

		return (
			<div>
				<fieldset>
					<h4 className="section-title">
						Service
						<QuickCheckoutFavoriteStar
							entityType="service"
							entityPkey={object.pkey}
							disabled={!object.pkey}
							disabledReason="Save this service before adding it to Quick Checkout favorites."
						/>
					</h4>
					<div className="row">
						<div className="col-md">
							<div className="form-group">
								<Framework.Elements.TextField
									label="Name"
									property={properties.name}
									value={object.name}
									error={object.name_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.DollarAmount
									label="Price"
									property={properties.price}
									value={object.price}
									error={object.price_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.DollarAmount
									label="Service Cost"
									property={properties.price_purchase}
									value={object.price_purchase}
									error={object.price_purchase_error}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
							<div className="form-group">
								<Framework.Elements.ButtonSwitch
									value={!!object.taxable}
									error={object.taxable_error}
									property={properties.taxable}
									update={this.handleTextFieldPropertyUpdate}
									labelTrue="Taxable"
									labelFalse="Non-Taxable"
									project={'pos'}
								/>
							</div>
						</div>
						<div className="col-md">
							<div className="form-group">
								<Framework.Elements.TextField
									label="Notes"
									property={properties.notes}
									value={object.notes}
									error={object.notes_error}
									multiline={6}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>
						</div>
					</div>
				</fieldset>

				<div className={classNames("loader", {active: this.state.loading})}>
					<ClipLoader color="#4A4A4A" loading={this.state.loading} />
				</div>
			</div>
		);
	};
}
